import { isEmpty } from '@/utils/is';
import { getPosition } from '../utils/filter';

export default {
  data() {
    return {
      icon: {
        type: 'image',
        config: {
          src: '/static/image/cotton/detection.png'
        }
      },
      byDeviceType: [
        'deviceTypeName',
        'dynamicInfoMap',
        'state',
        'col2_dynamicInfoMap',
        'col2_state'
      ],
      byPlace: ['dynamicInfoMap', 'deviceTypeName', 'state', 'col2_deviceTypeName', 'col2_state']
    };
  },
  methods: {
    makeDeviceTypeColumn(flag) {
      return (
        <el-table-column
          prop="deviceTypeName"
          key={flag ? 'col2_deviceTypeName' : 'deviceTypeName'}
          label={`${this.$t('设备')}${flag ? '2' : ''}`}
          render-header={() => (
            <div class="col-flex">
              <img src="/static/image/device/device-icon.png" alt="" />
              <span>{this.$t('设备')}</span>
            </div>
          )}
          align="center"
          min-width={this.deviceMinWidth}
        >
          {({ row }) => {
            const r = flag ? row.col2 : row;

            if (isEmpty(r)) return <span></span>;

            const prop = this.isGroupByPlace ? 'name' : 'deviceTypeName';

            const text = r[prop];

            const snText = this.isGroupByPlace ? `(${r.outterSn || r.sn})` : '';

            const fullText = `${text}${snText}`;

            const id = this.isGroupByPlace ? `sn-${r.sn}` : '';

            const formatter = () => {
              return fullText;
            };

            return (
              <Col key={r.sn} device={r} id={id} formatter={formatter} is-inline={this.isInline} />
            );
          }}
        </el-table-column>
      );
    },
    makePositionColumn(flag) {
      return (
        <el-table-column
          prop="dynamicInfoMap"
          label={`${this.$t('位置')}${flag ? '2' : ''}`}
          render-header={() => (
            <div class="col-flex">
              <img src="/static/image/device/position-icon.png" alt="" />
              <span>{this.$t('位置')}</span>
            </div>
          )}
          align="center"
          min-width={this.positionMinWidth}
        >
          {({ row }) => {
            const r = flag ? row.col2 || {} : row;

            if (isEmpty(r)) return <span></span>;

            const posText = getPosition(
              r.dynamicInfoMap,
              this.isGroupByPlace ? this.$t('其他') : r.name || r.sn
            );

            const snText = !this.isGroupByPlace ? `(${r.outterSn || r.sn})` : '';

            const fullText = `${posText}${snText}`;

            const id = !this.isGroupByPlace ? `sn-${r.sn}` : '';

            return <MultiLineText text={fullText} id={id} share-out={true} />;
          }}
        </el-table-column>
      );
    },
    makeStateColumns(flag) {
      const texts = ['正常', '故障', '报警'];
      const makeItem = (text, ind) => (
        <el-table-column
          class-name="state-col"
          prop="state"
          label={this.$t(text)}
          align="center"
          width={this.stateMinWidth}
        >
          {({ row }) => {
            const r = flag ? row.col2 : row;

            return (
              r && (
                <StateIcon
                  value={r}
                  onDisposition={() => {
                    if (ind !== 2) return;

                    this.handleAlarmIconClick(r);
                  }}
                  state={ind}
                />
              )
            );
          }}
        </el-table-column>
      );

      return texts.map((e, i) => makeItem(e, i));
    },
    getColumns() {
      const dict = {
        deviceTypeName: () => this.makeDeviceTypeColumn(),
        dynamicInfoMap: () => this.makePositionColumn(),
        state: () => this.makeStateColumns(),
        col2_dynamicInfoMap: () => this.makePositionColumn(true),
        col2_deviceTypeName: () => this.makeDeviceTypeColumn(true),
        col2_state: () => this.makeStateColumns(true)
      };

      const len = this.isInline ? 3 : 5;

      if (this.isGroupByPlace) {
        const res = this.byPlace
          .slice(0, len)
          .map(e => dict[e]?.())
          .flat();

        return res;
      } else {
        return this.byDeviceType
          .slice(0, len)
          .map(e => dict[e]?.())
          .flat();
      }
    }
  },
  render() {
    const { title, deviceList, monitorConfig, icon } = this;

    // data={tableConfig.data}
    // span-method={this.spanHandler}

    return (
      <div ref="container">
        <MCard
          class="cotton-monitor_list"
          title={title}
          theme="light"
          title-align="center"
          style={{ '--font-size': `${monitorConfig.fontSize}px` }}
          icon={icon}
        >
          <el-table
            key={`${+this.isGroupByPlace}-${+this.isInline}`}
            class="cotton-monitor-table"
            ref="table"
            height="100%"
            style="width: 100%"
            border
            data={deviceList}
            on-row-contextmenu={this.handleRightClick}
            gutter-width={0}
          >
            {this.getColumns()}
          </el-table>
        </MCard>
      </div>
    );
  }
};
